const formatPhoneNumber = number => {
  var cleaned = ('' + number).replace(/\D/g, '')
  var match = cleaned.match(/^(1|)?(\d{1,3})(\d{1,3})?(\d{1,4})?$/)
  if (match) {
    return [
      '',
      '(',
      match[2],
      match[3] ? ') ' : '',
      match[3],
      match[3] && match[4] ? '-' : '',
      match[4]
    ].join('')
  } else {
    return number
  }
}

export default formatPhoneNumber
